import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "documents-spreadsheets-photos",
  courseId: "investigations",
  order: 6,
  title: "Other evidence",
  subtitle: "Documents, spreadsheets, photos",
  summary:
    "Reports, commissary ledgers, phone dumps, and screenshots are read alongside the calls. Each file type gets its own analysis, with leads anchored to a page, a row, or a region of the image.",
  learn: [
    "Upload PDFs, Word files, spreadsheets, and photos",
    "Classify a document as official or evidence",
    "Read leads anchored to pages, rows, and image regions",
  ],
  minutes: 4,
  releasedAt: "2026-08-24T00:00:00.000Z",
  gate: "investigations",
  body: [
    {
      type: "paragraph",
      text: "Drop the files on the Files tab the same way you upload calls. What the AI does with each type differs.",
    },
    {
      type: "bullets",
      items: [
        "PDFs and Word files: text is extracted (OCR for scans), split into pages, and analyzed for leads, entities, key dates, and a description. Leads highlight the exact lines on the page.",
        "Spreadsheets and CSVs: rows are loaded into a table with date, amount, and counterparty columns promoted. The AI reads computed digests (top counterparties, largest entries), never the raw rows. Leads highlight the flagged rows.",
        "Photos: OCR plus a vision pass. Leads point at a quote's lines or a drawn region (a weapon, a plate). Message timestamps and dated receipts feed the Timeline.",
        "Video: treated as footage. See the Investigation footage lesson.",
      ],
    },
    {
      type: "steps",
      items: [
        "Open a file to see its viewer with lead overlays and the lead rail. Hovering either side highlights the other.",
        "Check the classification chip on a document: official (your agency's own work product) or evidence (third-party material).",
        "If the AI got it wrong, change the chip. Your setting is never overwritten.",
      ],
    },
    {
      type: "paragraph",
      text: "Reclassifying an analyzed document keeps its existing leads and offers a re-run.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Official vs evidence",
      text: "Official documents are authoritative context, not suspects. They only ever produce discrepancy and report-note leads. Evidence documents are mined like calls.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "Upload the case report early. Names, dates, and locations in it anchor how every later call is read.",
    },
    {
      type: "paragraph",
      text: "People and timeline shows where the entities and dates from these files end up.",
    },
  ],
  related: ["work-the-leads-queue", "people-connections-timeline", "footage-in-investigations"],
};

export default lesson;
